import type { CatalogCarouselItem } from '~/features/experiments/ab_plp_redesign_2025/models/catalog-carousel-item';

export function getCatalogFreeTrialCarouselItem(): CatalogCarouselItem {
  return {
    title: 'Try our **top Agentic AI\nNanodegree program** for free',
    ctaLabel: 'Try For Free',
    ctaUrl: '/course/agentic-ai--nd900',
    theme: 'agentic-ai',
    backgroundImage: '/images/experiments/ab_plp_redesign_2025/agentic-ai-card-bg.png',
    key: 'free-trial',
    overlay: true,
    eventPayload: {
      type: 'click' as const,
      name: 'catalogCtaClicked',
      label: 'agentic-ai-ft-2026 cta clicked',
      value: 'nd900',
    },
  };
}
